import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 32px 10px 10px 10px;
  font-size: 14px;
  min-width: 240px;
  max-width: 640px;
  overflow: auto;
`;

export const Heading = styled.h1`
  margin: 0 0 24px 0;
  font-size: 30px;
  font-weight: bold;
  @media only screen and (max-width: 500px) {
    font-size: 16px;
  }
`

export const Text = styled.p`
  margin-top: 0;
  margin-bottom: 16px;
  font-size: 16px;
  @media only screen and (max-width: 500px) {
    font-size: 12px;
  }
`
